import { AuthGuardService } from "./auth.guard";
import { CloseAuthGuardService } from "./close-auth.guard";
import { SignupAuthGuardService } from "./signup-auth.guard";
import { SuperAdminGuard } from "./super-admin.guard";
import { TeacherGuard } from "./teacher.guard";
import { MemberGuard } from "./member.guard";

// QSL-9973 (Admin Nav Phase 5): CRMGuard / REVIEWERGuard / ENGINEERGuard
// and LegacyShellRedirectGuard were removed alongside the legacy shells.
// All admin-tier roles now share a single /super-admin/* URL tree gated by
// SuperAdminGuard.

export const GUARDS = [
  AuthGuardService,
  CloseAuthGuardService,
  SignupAuthGuardService,
  SuperAdminGuard,
  TeacherGuard,
  MemberGuard,
];
export * from "./auth.guard";
export * from "./close-auth.guard";
export * from "./signup-auth.guard";
export * from "./super-admin.guard";
export * from "./teacher.guard";
export * from "./member.guard";
